// Shared file/upload constants: size limits and MIME content types. Used by both
// the API (Zod validation, S3 content types) and the frontends (upload widgets).
// Dependency-free; safe to import from any package.

/** Bytes in one mebibyte (MiB). */
export const BYTES_PER_MB = 1024 * 1024;

/** Max size for support ticket attachments. */
export const MAX_SUPPORT_ATTACHMENT_BYTES = 10 * BYTES_PER_MB;

/** Max size for general document/file uploads (RFC, accounts, payroll). */
export const MAX_UPLOAD_BYTES = 50 * BYTES_PER_MB;

/** Default expiry (in seconds) for S3 presigned upload/download URLs (1 hour). */
export const PRESIGNED_URL_TTL_SECONDS = 3600;

/** Common MIME / Content-Type values used across the app. */
export const MIME_TYPES = {
  PDF: 'application/pdf',
  CSV: 'text/csv',
  JSON: 'application/json',
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  XLS: 'application/vnd.ms-excel',
} as const;

export type MimeType = (typeof MIME_TYPES)[keyof typeof MIME_TYPES];
